import(/* webpackMode: "eager" */ "/vercel/path0/src/app/launch/page.tsx");
